import React, { FC } from 'react';
import styled from 'styled-components';
import {
  ProjectTemplateSpaceData,
  ProjectTemplateSpaceEnumType,
} from 'data/templates/projects/types';
import { unreachable } from 'utils/unreachable';
import { RenderProjectSpaceName } from './project-space-name';
import { RenderTaskName } from './space-tab-name';

const FOCUS_WRAPPER_LAYER_ZINDEX = 1;

const FocusWrapper = styled.div<{ width }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  width: ${({ width }) => width};
  border: solid 2px transparent;
  transition: border-color ease-in var(--animation-duration-fast);
`;

const DetailCell = styled.div`
  position: relative;
  width: 100%;
  z-index: ${FOCUS_WRAPPER_LAYER_ZINDEX + 1};

  &:focus-within + ${FocusWrapper} {
    border-color: var(--primary-color);
    z-index: ${FOCUS_WRAPPER_LAYER_ZINDEX};
  }
`;

const renderCell = (data: ProjectTemplateSpaceData, onClick: () => void) => {
  switch (data.type) {
    case ProjectTemplateSpaceEnumType.ProjectSpaceValue:
      return (
        <RenderProjectSpaceName
          onClick={onClick}
          spaceName={data.title}
          isPrivate={data.private}
        />
      );
    case ProjectTemplateSpaceEnumType.SpaceTabValue:
      return (
        <RenderTaskName
          onClick={onClick}
          spaceTabName={data.title}
          spaceTab={data}
        />
      );
    default:
      return unreachable(data);
  }
};

export const StatusNameCell: FC<{
  data: ProjectTemplateSpaceData;
  onClick(): void;
}> = ({ data, onClick }) => {
  return (
    <>
      <DetailCell>{renderCell(data, onClick)}</DetailCell>
    </>
  );
};
